import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { WebView } from '@awesome-cordova-plugins/ionic-webview/ngx';
import { DatePipe } from '@angular/common';
import { MIMETypesEnum } from '../../../models/mimetype.enum';
import { UtilsService } from '../utils/utils.service';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { FileOpener } from '@capacitor-community/file-opener';
import { Observable, catchError, lastValueFrom, map, timeout } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { HttpHelpersService } from '../http-helpers/http-helpers.service';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';
@Injectable({
  providedIn: 'root'
})
export class FileHelpersService {
  private window: any = window;
  private url: string;

  constructor(
    private platform: Platform,
    private file: File,
    private webview: WebView,
    private datePipe: DatePipe,
    private utils: UtilsService,
    private nativeHttp: HTTP,
    private http: HttpClient,
    private httpHelpers: HttpHelpersService,
    private translate : TranslateService
  ) {
    this.url = this.httpHelpers.getUrl();
  }

  async takePicture() {
    const capturedPhoto = await Camera.getPhoto({
      quality: 70,
      resultType: CameraResultType.Uri,
      source: CameraSource.Camera,
      saveToGallery: false
    })
    const newEntry = await this.copyFileToLocalDir(capturedPhoto);
    return newEntry;
  }

  async choosePicture() {
    const selectedImage = await Camera.pickImages({ quality: 60, limit: 1 });
    if (selectedImage?.photos.length) {
      const image = selectedImage.photos[0];
      const newEntry = await this.copyFileToLocalDir(image);
      return newEntry;
    }
  }

  async copyFileToLocalDir(image) {
    image.url = Capacitor.convertFileSrc(image.path);
    let base64Data = await this.readAsBase64(image);
    const extension = image.url.substring(image.url.lastIndexOf('.'));
    const newFileName = this.setNewFileName(extension);
    const savedFile = await Filesystem.writeFile({
      path: newFileName,
      data: base64Data,
      directory: Directory.Data
    });
    const newEntry = {
      name: newFileName,
      path: image.url,
      filePath: savedFile.uri,
    };
    return newEntry;
  }

  pathForImage(img) {
    if (img === null) {
      return '';
    } else {
      let converted = this.webview.convertFileSrc(img);
      return converted;
    }
  }

  getDateActualWithFormat(FORMAT: string) {
    const fechaActual = new Date();
    const dateFormated = this.datePipe.transform(fechaActual, FORMAT);
    return dateFormated;
  }

  hash(length, chars) {
    const charst = chars + '0123456789abcdefghijklmnopqrstuvwxyz';
    let result = '';
    for (let i = length; i > 0; --i)
      result += charst[Math.round(Math.random() * (charst.length - 1))];
    return result;
  }

  setNewFileName(extension) {
    const dateFormated = this.getDateActualWithFormat('yyyyMMdd_HHmmss');
    const timestamp = this.getDateActualWithFormat('yyyyMMddHHmmss');
    let newImageName = this.hash(29, dateFormated) + 't' + timestamp + extension;
    return newImageName
  }


  async downloadFiles(files): Promise<any> {
    let targetPath: string = this.platform.is("ios") ? this.file.dataDirectory : this.file.externalDataDirectory;

    const dirName: string = files[0].nombre.substring(0, files[0].nombre.lastIndexOf('/'))
    const [module, app, userId] = dirName.split('/');

    try {
      await this.file.checkDir(targetPath, dirName);
    } catch (existsError) {
      if (existsError.code === 1) {
        try {
          await this.file.createDir(targetPath, module, true);
          await this.file.createDir(`${targetPath}/${module}`, app, true);
          await this.file.createDir(`${targetPath}/${module}/${app}`, userId, true);
        }
        catch (creationError) { }
      }
    } finally {
      try {
        const downloadedFilesPromises = [];
        for (const file of files) {
          downloadedFilesPromises.push(this.nativeHttp.downloadFile(file.url, {}, {}, targetPath + file.nombre));
        }
        const allResponses = await Promise.all(downloadedFilesPromises);
        // this.utils.showMessage('Descarga Finalizada');
        return Promise.resolve(allResponses);
      } catch (e) {
        console.log(e);

        this.utils.showMessage(this.translate.instant('file-helpers.Error al descargar archivos'));
        return Promise.reject(e);
      }
    }
  }

  async openFile(file, openAtOnce = false) {

    if (this.platform.is('android') || this.platform.is('ios')) {

      //Se obtiene el nombre real del path de S3
      file.name = this.utils.getFileNameFromS3(file);
      //-----    

      const fileAvailable: any = await this.checkIfFileIsInDevice(file.name)
      if (fileAvailable.notFound) {
        const downloadResult = await this.downloadFileNew(file, openAtOnce)
        return downloadResult;
      } else {
        try {
          await FileOpener.open({
            filePath: fileAvailable.uri,    
            contentType: MIMETypesEnum[this.utils.getFileExtension(file.name)]
          });
        } catch (e) {
          this.openInWebViewer(file);
        }
      }
    } else {
      window.open(file, '_blank');
    }
  }

  async checkIfFileIsInDevice(file) {
    try {
      const fileData = await Filesystem.stat({
        path: file,
        directory: Directory.Data
      })
      return fileData;
    } catch (e) {
      return {
        notFound: true,
        file
      };
    }
  }

  async downloadFileNew(file, openAtOnce = false) {

    const name = file.archivo || file.nombre;
    file.fileNameToShow = this.utils.getFileNameWithoutExtension(name);
    
    this.utils.showMessage(
      this.translate.instant('file-helpers.Descargando archivo : ') + file.fileNameToShow
    );

    const download = this.http.get(file.url, {
      responseType: 'blob',
      observe: 'events',
      headers: { 'Cache-Control': 'no-cache' }
    }).pipe(timeout(120000))
    try {
      const downloadResponse: any = await lastValueFrom(download)
      if (downloadResponse.body && downloadResponse.status === 200) {
        const base64 = await this.blobToBase64(downloadResponse['body']) as string;
        await Filesystem.writeFile({
          path: file.name,
          data: base64,
          directory: Directory.Data
        })
        if (openAtOnce)
          this.openFile(file)
        return file;
      } else
        return '';
    } catch (e) {
      return {
        error: true,
        status: e?.status,
        file
      }
    }
  }

async openInWebViewer(file: any) {

    const extension =
      this.utils.getFileExtension(file.archivo || file.nombre);

    if (['doc', 'docx', 'xls', 'xlsx'].includes(extension)) {

      const viewer =
        'https://view.officeapps.live.com/op/view.aspx?src=' +
        encodeURIComponent(file.url);

      window.open(viewer, '_blank');
      return;
    }

    if (extension === 'pdf') {
      window.open(file.url, '_blank');
      return;
    }
    this.utils.showMessage(this.translate.instant('file-helpers.No hay aplicación para abrir este tipo de archivo.'));
  }

  getActasEntrega(company, unitId): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.getHeader()
    }
    return this.http.get<Response>(`${this.url}/empresas/${company}/propiedades/${unitId}/archivos/acta    `,
      httpOptions)
      .pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('file-helpers.obtener actas de entrega')))
      );
  }

  getFiles(company, projectId, unitType, unitId): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.getHeader()
    }
    return this.http.get<Response>(`${this.url}/empresas/${company}/propiedades/${unitId}/archivos/generales?tipo=${unitType}&proyecto_id=${projectId}`,
      httpOptions)
      .pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('file-helpers.obtener archivos generales')))
      );
  }


  getFileReader(): FileReader {
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any)["__zone_symbol__originalInstance"];
    return zoneOriginalInstance || fileReader;
  }

  blobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
    const reader = this.getFileReader();
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  })

  async readAsBase64(cameraPhoto) {
    // Fetch the photo, read as a blob, then convert to base64 format
    const response = await fetch(cameraPhoto.url);
    const blob = await response.blob();
    return await this.blobToBase64(blob) as string;
  }

  b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
